import { BaseDataService } from "../../../services/base/BaseDataService";
import { ProjectDocFolderCUser } from "../../workflows/models/ProjectDocFolderCUser";
import { ProjectDocFolderCUserQuery } from "../models/ProjectDocFolderCUserQuery";

export class ProjectDocFolderCUserService extends BaseDataService<ProjectDocFolderCUser, ProjectDocFolderCUserQuery> {
  protected prefixUrl: string = `ProjectDocFolderCUsers`;

  findFolderApprovers(folderId: number, workflowId: number) {
    return this.api.get<ProjectDocFolderCUser[]>(
      `${this.prefixUrl}/CUsersApprovers?folderId=${folderId}`
    );
  }
}
